import {Item, Menu} from 'react-contexify';

import styled, {css} from 'styled-components';

import type {ThemeColor} from '@yourcoach/shared/styles/theme';

import {ms} from '@yourcoach/shared/styles/normalizeSize';
import {getColor} from '@yourcoach/shared/styles/utils';

const SMenu = styled(Menu)`
  border-radius: ${ms(12)};
  padding: 0;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
  overflow: hidden;
`;

const SItem = styled(Item)<{
  iconFillColor?: ThemeColor;
  variant?: 'error' | 'success';
}>`
  border-top: 1px solid ${getColor('gray10')};
  transition: all 0.3s ease;

  &:first-child {
    border-top: none;
  }

  &:hover {
    background-color: ${getColor('background2')};
    ${p =>
      p.variant === 'success' &&
      css`
        background-color: ${getColor('background3')};

        span {
          color: ${getColor('icon4')};
        }
      `}
  }

  && > .contexify_itemContent {
    color: ${getColor('text1')};
    font-size: ${ms(16)};
    line-height: ${ms(20)};
    font-weight: 600;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: ${ms(12)};
    padding: ${ms(12)};

    ${p =>
      p.variant === 'error' &&
      css`
        color: ${getColor('error')};
      `}

    svg {
      width: ${ms(24)};
      height: ${ms(24)};
      fill: ${p => getColor(p.iconFillColor ?? 'icon1')};

      ${p =>
        p.variant === 'error' &&
        css`
          fill: ${getColor('error')};
        `}
      ${p =>
        p.variant === 'success' &&
        css`
          fill: ${getColor('icon3')};
        `}
    }
  }

  &&:not(.contexify_item--disabled):hover > .contexify_itemContent {
    background: none !important;
    color: ${getColor('text1')} !important;

    ${p =>
      p.variant === 'error' &&
      css`
        color: ${getColor('error')} !important;
      `}

    svg {
      fill: ${p => getColor(p.iconFillColor ?? 'icon1')} !important;

      ${p =>
        p.variant === 'error' &&
        css`
          fill: ${getColor('error')} !important;
        `}
      ${p =>
        p.variant === 'success' &&
        css`
          fill: ${getColor('icon4')} !important;
        `}
    }
  }
`;

export const ContextMenu = {
  Item: SItem,
  Menu: SMenu,
};
